<template>
  <div>
    <label class="block text-sm font-medium leading-5 text-gray-700">
      {{ label }}
    </label>
    <div class="mt-1 sm:mt-0 sm:col-span-2">
      <div class="max-w-lg flex rounded-md shadow-sm">
        <textarea
          rows="3"
          class="form-textarea block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5"
        />
      </div>
      <p
        v-if="explainer !== ''"
        class="mt-2 text-sm text-gray-500"
      >
        {{ explainer }}
      </p>
    </div>
  </div>
</template>

<script>
export default {

  props: {
    label: {
      type: String,
      default: '',
    },
    explainer: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      input: '',
    };
  },

  watch: {
    input() {
      this.$emit('change', this.input);
    },
  },

  mounted() {
    this.input = this.value;
  },

};
</script>
